import { createEntryPoint } from '#packages/apilib';
import { RtlLtrSettingsManagerKey } from './publicApiKey';
import {
  RtlLtrSettingsManagerApi,
  updateRtlLtrSettingsPanelIfNeeded,
} from './rtlLtrSettingsManagerApi';
import { RtlLtrSettingsManagerScope } from './rtlLtrSettingsManagerScope';

export const RtlLtrSettingsManagerEntryPoint = createEntryPoint({
  name: 'RtlLtrSettingsManager',
  Scope: RtlLtrSettingsManagerScope,
  publicApi({ contributeApi }) {
    contributeApi(RtlLtrSettingsManagerKey, RtlLtrSettingsManagerApi);
  },
  async initialize(scope: RtlLtrSettingsManagerScope) {
    const { editorAPI, editorCoreAPI } = scope;

    await Promise.all([
      new Promise((resolve) =>
        editorAPI.registerInitUserPrefsCallback(resolve),
      ),
      editorCoreAPI.hooks.stageIsReadyAndVisible.promise,
    ]);

    void updateRtlLtrSettingsPanelIfNeeded(scope);
  },
});
